// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';
// import { distinctUntilChanged } from 'rxjs/operators';
// import { PreconfiguredSub } from '../interfaces/preconfiguredSubs.interface';

// @Injectable({
//   providedIn: 'root',
// })
// export class PreconfigSubServiceService {
//   private readonly subscriptionData =
//     new BehaviorSubject<PreconfiguredSub | null>(null);

//   setSubscriptionData(data: PreconfiguredSub) {
//     if (
//       JSON.stringify(this.subscriptionData.getValue()) !== JSON.stringify(data)
//     ) {
//       console.log('Setting subscription data:', data);
//       this.subscriptionData.next(data);
//     } else {
//       console.log('Subscription data is unchanged. Skipping update.');
//     }
//   }

//   getSubscriptionData() {
//     return this.subscriptionData
//       .asObservable()
//       .pipe(
//         distinctUntilChanged(
//           (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
//         )
//       );
//   }
// }
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { PreconfiguredSub } from '../interfaces/preconfiguredSubs.interface';

@Injectable({
  providedIn: 'root',
})
export class PreconfigSubServiceService {
  private readonly subscriptions = new BehaviorSubject<PreconfiguredSub[]>([]); // Store an array of subscriptions

  // Set all subscriptions
  setSubscriptionData(data: PreconfiguredSub[]) {
    if (
      JSON.stringify(this.subscriptions.getValue()) !== JSON.stringify(data)
    ) {
      console.log('Setting subscription data:', data);
      this.subscriptions.next(data);
    } else {
      console.log('Subscription data is unchanged. Skipping update.');
    }
  }

  // Get all subscriptions as an observable
  getAllSubscriptions() {
    return this.subscriptions
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        )
      );
  }

  // Get a subscription by its recordId
  getSubscriptionById(recordId: string): PreconfiguredSub | null {
    const currentSubscriptions = this.subscriptions.getValue();
    return (
      currentSubscriptions.find((sub) => sub.recordId === recordId) || null
    );
  }
}
